import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "w-100 d-flex flex-row justify-content-between mb-10 mt-10" }
const _hoisted_7 = { class: "d-flex flex-row gap-5" }
const _hoisted_8 = ["data-kt-indicator"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save as New Tempalate ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["onClick", "data-kt-indicator"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Send Notifications ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_EmailDefaultEditorForm = _resolveComponent("EmailDefaultEditorForm")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      "validation-schema": _ctx.formSchema,
      "initial-values": _ctx.formData,
      ref: "sendNotificationForm"
    }, {
      default: _withCtx(({ handleSubmit, validate }) => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.handleFormSubmit)), ["prevent"]),
          class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
          id: "send-notification-form",
          novalidate: ""
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormField, {
              required: false,
              name: "template",
              containerClass: "col-lg-6 col-md-6 col-12",
              label: "Template Name",
              placeholder: "Template Name",
              type: "text"
            }),
            _createVNode(_component_FormField, {
              required: false,
              name: "delivery_date",
              containerClass: "col-lg-3 col-md-3 col-12",
              label: "Delivery Date",
              placeholder: "Delivery Date",
              type: "datepicker"
            }),
            _createVNode(_component_FormField, {
              required: false,
              name: "delivery_time",
              containerClass: "col-lg-3 col-md-3 col-12",
              label: "Delivery Time (+10H QLD)",
              placeholder: "Delivery Time",
              type: "timepicker"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormField, {
              required: false,
              name: "subject",
              containerClass: "col-lg-12 col-md-12 col-12",
              label: "Subject",
              placeholder: "Subject",
              type: "text"
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_EmailDefaultEditorForm, {
              class: "col-lg-12 col-md-12 col-12",
              modelValue: _ctx.templateBody,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.templateBody) = $event)),
              style: {"width":"100%"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handeCreateTemplate && _ctx.handeCreateTemplate(...args))),
                class: "btn btn-link pt-5 align-middle",
                "data-kt-indicator": _ctx.loadSaveTemplate ? 'on' : null
              }, _hoisted_11, 8, _hoisted_8)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handePreviewEmail && _ctx.handePreviewEmail(...args))),
                class: "btn btn-link pt-5 align-middle"
              }, " Preview Email "),
              _createElementVNode("button", {
                onClick: validate,
                class: "btn btn-new-design-primary fw-bolder ms-4",
                "data-kt-indicator": _ctx.formSubmitted ? 'on' : null
              }, _hoisted_15, 8, _hoisted_12)
            ])
          ])
        ], 40, _hoisted_2)
      ]),
      _: 1
    }, 8, ["validation-schema", "initial-values"])
  ]))
}